import { getValue } from "@utils/lodash";
import "./notificationbar.scss";
import Dropdown from "../common/Dropdown";
export default function ReleaseCustomNavigationBar(props: any) {
  return (
    <section className="navigation-bar-wrapper">
      <div className="d-flex align-items-center justify-content-between">
        <div className="d-flex align-items-center">
          <p className="navigation-bar-wrapper__selected">
            {getValue(props, `selectedIndex.length`, 0)} Selected
          </p>
          {getValue(props, `permissions`, []).includes("update") && (
            <>
              {/* <div
                className="navigation-bar-wrapper__inactive-count d-flex cursor-pointer"
                onClick={() => props.handleSubmit("active")}
              >
                <img src="/images/assignment.svg" className="img-fluid" />
                <h6>SAVE</h6>
              </div> */}
              <div
                className="navigation-bar-wrapper__inactive-count d-flex cursor-pointer"
                onClick={() => props.handleAuditCompleteConfirm()}
              >
                <img src="/images/assignment.svg" className="img-fluid" />
                <h6>Audit Complete</h6>
              </div>
            </>
          )}
        </div>
        <img
          src="/images/close-white.svg"
          className="img-fluid navigation-bar-wrapper__close-btn"
          onClick={props.handleRemoveNavItems}
        />
      </div>
    </section>
  );
}
